import { ButtonTypes } from '@paywithextend/components'
import Button from 'ext-ui/components/Button/Button'
import { Location } from 'history'
import React from 'react'
import HoverableLink from 'src/components/HoverableLink/HoverableLink'
import SvgToolbarDownload from 'src/components/Svgs/SvgToolbarDownload'
import { useTranslate } from 'src/localization/Trns'
import { LocationState } from 'src/redux/createRootReducer'

export interface UtilityToolbarDownloadProps {
  onClick?: () => void
  to?: Location<LocationState> | string
  disabled?: boolean
  loading?: boolean
  /** See `UtilityToolbarFilterButton`'s `withLabel`. EX-40736. */
  withLabel?: boolean
}

const UtilityToolbarDownload: React.FC<UtilityToolbarDownloadProps> = ({
  disabled,
  loading,
  onClick,
  to,
  withLabel,
}): React.ReactElement => {
  const translate = useTranslate()

  /*
    Labelled mode renders the same ext-ui `toolbar` Button the filter control
    uses, not the bare `HoverableLink` — that link has no surface of its own, so
    a labelled version of it sat next to a bordered Filter button looking like
    plain text. Same variant, same `dropShadow={false}`, so the two match.

    The link is kept for every other report, and for the `to` form, which
    navigates rather than calling back.
  */
  if (withLabel === true && to === undefined) {
    return (
      <Button
        type={ButtonTypes.button}
        variant={'toolbar'}
        dropShadow={false}
        disabled={disabled}
        loading={loading}
        onClick={onClick}
        aria-label={translate('Export')}
        data-testid="downloadOptionsBtn"
      >
        <SvgToolbarDownload />
        <span>{translate('Export')}</span>
      </Button>
    )
  }

  return (
    <HoverableLink
      ariaLabelSource={'Download'}
      disabled={disabled}
      loading={loading}
      onClick={onClick}
      to={to}
      testId="downloadOptionsBtn"
    >
      <SvgToolbarDownload />
    </HoverableLink>
  )
}

export default UtilityToolbarDownload
